import styled from 'styled-components'

import { Arrow, ArrowSoft } from './Icons'

import { customMedia } from '../../utils/breakpoints';

export const ContainerShowcase = styled.div`
  position: relative;
  background: ${props => props.theme.showcase.background};

  ${customMedia.greaterThan('lg')`
    max-width: 1366px;
    margin: 0 auto;
  `}
`

export const ShowcaseTitle = styled.h2`
  /* Qual exame você procura? */
  height: 68px;
  left: 136px;
  padding: 48px 135px 32px 135px;

  /* Desktop/Heading/XL */
  font-family: ${props => props.theme.font};
  font-size: 40px;
  font-weight: bold;
  line-height: 48px;

  ${customMedia.lessThan('md')`
      padding: 40px 144px 24px 144px;
  `}

  ${customMedia.lessThan('sm')`
    /* Qual exame você procura? */
    height: 68px;
    padding: 40px 0 29px 110px;

    /* Desktop/Heading/XL */
    font-family: ${props => props.theme.font};
    font-size: 24px;
    font-weight: bold;
    line-height: 32px;
  `}

  ${customMedia.lessThan('xs')`
    /* Qual exame você procura? */
    height: 68px;
    left: 17px;
    padding: 40.9px 16px 15.83px 16px;

    /* Desktop/Heading/XL */
    font-family: ${props => props.theme.font};
    font-size: 24px;
    font-weight: bold;
    line-height: 32px;
  `}

  display: flex;
  align-items: center;
  letter-spacing: -1px;

  /* Brand/Primary/40 (base) */
  color: ${props => props.theme.showcase.textSectionTitle};
`

export const MostWantedTitle = styled.h2`
  /* Exames mais pesquisados */
  position: relative;
  padding: 40px 135px 0 135px;

  /* Desktop/Subtitle/SM */
  font-family: ${props => props.theme.font};
  font-size: 24px;
  line-height: 32px;

  ${customMedia.lessThan('md')`
    padding: 32px 144px 0 144px;
  `}

  ${customMedia.lessThan('sm')`
    /* Exames mais pesquisados */
    position: relative;
    padding: 27px 110px 0 110px;

    /* Desktop/Subtitle/SM */
    font-family: ${props => props.theme.font};
    font-size: 20px;
    line-height: 24px;
  `}

  ${customMedia.lessThan('xs')`
    /* Exames mais pesquisados */
    position: relative;
    width: 234px;
    padding: 31.04px 16px 0 16px;

    /* Desktop/Subtitle/SM */
    font-family: ${props => props.theme.font};
    font-size: 20px;
    line-height: 24px;
  `}

  /* Brand/Primary/40 (base) */
  color: ${props => props.theme.showcase.textSectionTitle};
`

export const ContainerMostWanted = styled.div`
  flex-direction: row;
  padding: 32px 135px 0 135px;

  .slick-initialized .slick-slide {
    width: 218px !important;
  }

  ${customMedia.lessThan('md')`
    padding: 24px 0 0 144px;
    .slick-initialized .slick-slide {
      width: 244px !important;
    }
  `}

  ${customMedia.lessThan('sm')`
    padding: 24px 0 0 110px;
    .slick-initialized .slick-slide {
      width: 188px !important;
    }
  `}

  ${customMedia.lessThan('xs')`
    padding: 16px 0 0 16px;
    .slick-initialized .slick-slide {
      width: 215px !important;
    }
  `}
`
export const MainContainer = styled.div`
  position: static;
  width: 224px;
  ${customMedia.lessThan('md')`
  width: 244px;
  `}

  ${customMedia.lessThan('sm')`
    width: 188px;
  `}

  ${customMedia.lessThan('xs')`
    width: 224px;
  `}
  height: 243.21px;
  left: 10px;
  top: 10px;
`
export const ContainerMostWantedCard = styled.a`
  /* Auto Layout */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;

  position: static;
  width: 200px;
  ${customMedia.lessThan('md')`
    width: 220px;
  `}

  ${customMedia.lessThan('sm')`
    width: 172px;
  `}

  ${customMedia.lessThan('xs')`
    width: 216px;
  `}
  height: 233.21px;
  left: 10px;
  top: 10px;

  /* Neutral/On-Brand/00 */
  background: ${props => props.theme.showcase.background};

  /* Neutral/20 */
  border: 1px solid #E9E9E9;
  box-sizing: border-box;

  /* Shadow/02 */
  box-shadow: 0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08);
  border-radius: 8px;

  text-decoration: none;

  ${customMedia.lessThan('xs')`
    width: 200px;
  `}

`

// MostWantedCard
export const ContainerMostWantedCardTitle = styled.div`
  position: static;
  left: 16px;
  right: 16px;
  top: 16px;
  height: 70px;
`

export const MostWantedCardTitle = styled.h3`
  font-family: ${props => props.theme.font};
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  color: ${props => props.theme.showcase.textCardTitle};

  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
`

export const MostWantedCardTag =styled.div`
  /* Auto Layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 8px;
  color: ${props => props.theme.showcase.textTag};
  background-color: ${
    props => props.covered_health_insurance ?
      props.theme.showcase.coveredTag :
      props.theme.showcase.noCoveredTag
    };

  position: static;
  height: 24px;
  left: 0px;
  top: 0px;

  /* Brand/Base/Red */
  background: ${props => props.color};
  border-radius: 24px;

  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 0px;
`

export const MostWantedCardTagText =styled.p`
  /* ✏️ Text */
  position: static;
  height: 16px;
  left: calc(50% - 122px/2);
  top: calc(50% - 16px/2);

  /* Desktop/Caption */
  font-family: ${props => props.theme.font};
  font-size: 12px;
  line-height: 133%;
  /* identical to box height, or 16px */

  display: flex;
  align-items: center;

  /* Neutral/00 */
  color: ${props => props.theme.header.background};

  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 0px;
`

export const MostWantedCardValueTitle =styled.p`
  /* Particular a partir de */
  position: static;
  height: 16px;
  left: 0%;
  right: 0%;
  top: calc(50% - 16px/2 - 13.6px);

  /* Desktop/Caption */
  font-family: ${props => props.theme.font};
  font-size: 12px;
  line-height: 133%;
  /* identical to box height, or 16px */

  display: flex;
  align-items: center;

  /* Typeface/Inverse/On-Brand/Pure */
  color: rgba(22, 22, 22, 0.88);

  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 0px;
  padding: 23px 0 0 0;
`

export const MostWantedCardValue = styled.p`
  /* Mob/Heading/lg */
  font-family: ${props => props.theme.font};
  font-size: 24px;
  font-weight: bold;
  line-height: 29px;
  /* 120% or 29px */
  color: ${props => props.theme.showcase.text};
`

export const ContainerMostWantedCardInfo = styled.div`
  /* Auto Layout */
  display: flex;
  flex-direction: row;
  padding-top: 27px;
`

export const MostWantedCardInfo = styled.p`
  /* Label */
  position: static;
  width: 70px;
  height: 13px;
  left: 0px;
  top: 0px;

  /* Desktop/Text-Interaction/MD */
  font-family: ${props => props.theme.font};
  font-size: 14px;
  line-height: 115%;
  /* identical to box height, or 16px */

  display: flex;
  align-items: center;

  /* Interaction/Select/: Default */
  color: #4B4B4B;

  padding-right: 8.67px;
`

// Carousel
export const CarouselContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 2.7rem;

  ${customMedia.greaterThan('lg')`
    grid-template-columns: repeat(4, 1fr);
  `}

  ${customMedia.lessThan('sm')`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${customMedia.lessThan('xs')`
    grid-template-columns: repeat(1, 1fr);
  `}
`

export const ContainerMoreItens = styled.a`
  /* Auto Layout */
  display: flex;
  flex-direction: row;
  text-decoration: none;
  padding: 36px 0 51.79px 135px;
  color: ${props => props.theme.showcase.textSectionTitle};

  ${customMedia.lessThan('md')`
    padding: 28px 144px 43.79px 144px;
  `}

  ${customMedia.lessThan('sm')`
    padding: 28px 0 44.79px 110px;
  `}

  ${customMedia.lessThan('xs')`
    padding: 20px 0 44.31px 16px;
  `}
`

export const MoreItemsTitle = styled.p`
  font-family: ${props => props.theme.font};
  font-size: 16px;
  height: 20px;
  line-height: 24px;
  /* identical to box height, 150% or 24px */

  display: flex;
  align-items: center;

  /* Brand/Primary/40 (base) */
  color: ${props => props.theme.showcase.textSectionTitle};

  padding-right: 7px;
`

export const ArrowIcon = styled(Arrow)`
  width: 18px;
  height: 18px;
  color: ${props => props.theme.showcase.textSectionTitle};
`

export const ArrowIconSoft = styled(ArrowSoft)`
  width: 9px;
  height: 13px;
  color: ${props => props.theme.showcase.text};
`
